import * as Sentry from '@sentry/react'

// Initialize Sentry before any other imports to catch all errors
const sentryDsn = import.meta.env.VITE_SHELL_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
  })
}

import '@mysaiva/core/styles'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { setBackendUrl } from '@mysaiva/core/config'
import App from './App'
import './index.css'

// Configure backend URL for core library services
setBackendUrl(import.meta.env.VITE_REACT_APP_SAIVA_BACKEND_URL)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
